import React from "react";

export const FacebookOutlined = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0001 1.56006C6.68807 1.56006 1.56006 6.68807 1.56006 13.0001C1.56006 18.73 5.78638 23.472 11.2908 24.2989L11.8879 24.3893V15.3746H9.18537V13.5444H11.8879V11.114C11.8879 9.61744 12.2471 8.63176 12.8416 8.01334C13.4362 7.39492 14.3146 7.08303 15.5371 7.08303C16.5146 7.08303 16.8949 7.14225 17.2565 7.18662V8.68467H15.984C15.2619 8.68467 14.6695 9.08753 14.362 9.62412C14.0545 10.1607 13.9588 10.8014 13.9588 11.4543V13.5434H17.1428L16.8594 15.3736H13.9588V24.4035L14.5489 24.3233C20.1315 23.5661 24.4401 18.786 24.4401 13.0001C24.4401 6.68807 19.312 1.56006 13.0001 1.56006ZM13.0001 2.60006C18.75 2.60006 23.4001 7.25013 23.4001 13.0001C23.4001 18.0595 19.7787 22.2206 14.9988 23.1573V16.4136H17.7512L18.3554 12.5034H14.9988V11.4543C14.9988 10.9148 15.0975 10.4314 15.2639 10.1411C15.4303 9.85074 15.5906 9.72467 15.984 9.72467H18.2965V6.24514L17.8456 6.1842C17.5337 6.142 16.8216 6.04303 15.5371 6.04303C14.1315 6.04303 12.925 6.42593 12.0921 7.29225C11.2592 8.15856 10.8479 9.44852 10.8479 11.114V12.5044H8.14537V16.4146H10.8479V23.1248C6.1449 22.1286 2.60006 18.0048 2.60006 13.0001C2.60006 7.25013 7.25013 2.60006 13.0001 2.60006Z"
        fill="currentColor"
      />
    </svg>
  );
};
